"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import type { Post } from "@/payload-types";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
import { formatRelativeTime } from "@/utilities/formatting/date";
interface CategoryVideosSidebarProps {
  /** The initial video that was opened (stays at top of sidebar) */
  initialPost: Post;
  /** Other posts from the same category */
  categoryPosts: Post[];
  /** Currently active video ID (changes as user scrolls) */
  activePostId: number;
}
export function CategoryVideosSidebar(t0) {
  const $ = _c(10);
  const {
    initialPost,
    categoryPosts,
    activePostId
  } = t0;
  const nav = useNavigation();
  let result;
  if ($[0] !== categoryPosts || $[1] !== initialPost) {
    const seen = new Set();
    result = [];
    result.push(initialPost);
    seen.add(initialPost.id);
    for (const post of categoryPosts) {
      if (!seen.has(post.id)) {
        result.push(post);
        seen.add(post.id);
      }
    }
    $[0] = categoryPosts;
    $[1] = initialPost;
    $[2] = result;
  } else {
    result = $[2];
  }
  const orderedPosts = result;
  const getSource = _temp;
  let t1;
  if ($[3] !== activePostId || $[4] !== nav || $[5] !== orderedPosts) {
    t1 = orderedPosts.map(post_1 => {
      const isActive = post_1.id === activePostId;
      const url = nav.video(post_1.slug);
      return <a key={post_1.id} href={url} className="block group"><div className={`relative px-4 py-3 transition-colors ${isActive ? "bg-muted/50" : "hover:bg-muted/30"}`}>{isActive && <div className="absolute left-0 top-0 bottom-0 w-1 bg-amber-500" />}{!isActive && <div className="absolute left-0 top-0 bottom-0 w-1 bg-transparent group-hover:bg-muted" />}<h3 className="text-sm font-medium leading-snug line-clamp-3 group-hover:text-primary transition-colors">{post_1.title}</h3><div className="mt-1.5 flex items-center gap-1.5 text-xs text-foreground/50"><span>{formatRelativeTime(post_1.publishedAt)}</span><span>·</span><span>{getSource(post_1)}</span></div></div></a>;
    });
    $[3] = activePostId;
    $[4] = nav;
    $[5] = orderedPosts;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="px-4 py-6 text-center"><p className="text-sm text-foreground/40">You're all caught up!</p></div>;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1) {
    t3 = <aside className="hidden lg:block w-72 shrink-0 h-full overflow-y-auto border-r border-border bg-background"><div className="py-4">{t1}{t2}</div></aside>;
    $[8] = t1;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function _temp(post_0) {
  if (post_0.populatedAuthors && post_0.populatedAuthors.length > 0) {
    return post_0.populatedAuthors[0].name || "Staff";
  }
  return "Staff";
}